import React, {Component} from 'react'
import {} from 'prop-types'
import glamorous from 'glamorous'
import {getThemeStyles} from '../css/themes'

const ButtonStyled = glamorous.button({}, getThemeStyles('button'))

export default class Button extends Component {
  render() {
    return <ButtonStyled {...this.props}>{this.props.children}</ButtonStyled>
  }
}
